{
  "memberGroupProfile.removeFromGroup.error": "嘗試從群組移除成員時發生錯誤。",
  "memberGroupProfile.updateGroupPoints.error": "更新群組點數時發生錯誤。",
  "memberGroupProfile.updateGroupTier.error": "更新群組層級時發生錯誤。",
  "memberGroupProfile.removeFromGroup.deleteDialog.title": "您確定要從群組移除此成員 <br /> 嗎？",
  "memberGroupProfile.sperator.members": "成員",
  "memberGroupProfile.sperator.activity": "活動",
  "memberGroupProfile.title": "群組設定檔",
  "memberGroupProfile.headerTitle": "群組 ID：{groupId}",
  "memberGroupProfile.updateTierBtn.label": "更新層級",
  "memberGroupProfile.addNewMembersBtn.label": "新增成員",
  "memberGroupProfile.notification": "這可能最多需要 24 小時的時間，才能查看成員設定檔的所有更新內容。",
  "memberProfile.updateMembeerPoints.error": "更新成員點數時發生錯誤，請再試一次。",
  "memberProfile.updateMemberTier.error": "更新成員層級時發生錯誤，請再試一次。",
  "memberProfile.updateMemberPlan.error": "更新成員計劃時發生錯誤，請再試一次。",
  "memberProfile.updateMemberAdditionalBenefits.error": "更新成員福利時發生錯誤，請再試一次。",
  "memberProfile.title": "成員設定檔",
  "memberProfile.headerTitle": "成員 ID：{memberId}",
  "memberProfile.updateTierBtn.label": "更新層級",
  "memberProfile.updatePlanBtn.label": "移轉計劃",
  "memberProfile.updatePlanBtn.tootip": "您無法移轉屬於群組的成員。",
  "memberProfile.updateBenefitsBtn.label": "更新福利",
  "memberProfile.notification": "這可能最多需要 24 小時的時間，才能查看成員設定檔的所有更新內容。",
  "memberProfile.activity.title": "活動",
  "memberProfile.activity.downloadBtn.label": "下載憑證報表",
  "memberProfile.activity.downloadBtn.tooltip": "下載 CSV 格式的成員憑證報表。",
  "memberProfile.activity.pagination.pageSize": "顯示 {input} 列",
  "memberProfile.activity.pagination.recordsDisplayed": "{start}-{end}/{total}",
  "memberProfile.duplicateAlert": "我們找到多個包含此成員 ID 的聯絡人，因此無法顯示個人資料。",
  "memberProfileOverview.groupProfileBtn.tooltip": "群組設定檔",
  "memberProfileOverview.search.error": "搜尋期間發生錯誤，請再次嘗試搜尋。",
  "memberProfileOverview.search.noResults.lead": "沒有符合搜尋的結果，請使用不同搜尋準則再次嘗試搜尋。",
  "memberProfileOverview.search.noItems.title": "沒有符合搜尋的結果。",
  "memberProfileOverview.search.noResults.title": "沒有符合搜尋的結果。",
  "memberProfileOverview.deleteMemberIcon.tooltip": "刪除成員",
  "memberProfileOverview.deleteMemberDialog.headline": "刪除成員",
  "memberProfileOverview.deleteMemberDialog.notification": "如果您刪除此成員，則將永久取消忠誠會員。您無法復原此動作，系統已儲存成員資料。",
  "memberProfileOverview.deleteMemberDialog.memberToBeDeleted": "要刪除的成員",
  "memberProfileOverview.deleteMemberDialog.checkboxText": "從報表資料庫刪除所有忠誠資料。",
  "memberProfileOverview.deleteMemberDialog.deleteButton": "刪除",
  "memberProfileOverview.deleteMember.error": "刪除此成員時發生錯誤。 ",
  "memberProfileOverview.deleteGroupDialog.headline": "您確定要刪除此群組嗎？",
  "memberProfileOverview.deleteGroupDialog.content": "刪除此群組後，便會永久刪除所有忠誠資料。",
  "memberProfileOverview.deleteGroup.error": "刪除此群組時發生錯誤。",
  "memberProfileOverview.deleteGroup.success": "已刪除群組。",
  "memberProfileOverview.tableHeader.memberID": "成員 ID",
  "memberProfileOverview.tableHeader.tier": "層級",
  "memberProfileOverview.tableHeader.pointsToSpend": "花費點數",
  "memberProfileOverview.tableHeader.joinDate": "加入日期",
  "memberProfileOverveiw.memberTable.delete.label": "刪除成員",
  "memberProfileOverview.groupTableHeader.groupId": "群組 ID",
  "memberProfileOverview.groupTableHeader.tier": "層級",
  "memberProfileOverview.groupTableHeader.points": "狀態點數",
  "memberProfileOverview.groupTableHeader.members": "群組成員",
  "memberProfileOverview.groupTableHeader.created": "已建立",
  "memberProfileOverveiw.groupTable.delete.label": "刪除群組",
  "memberProfileOverveiw.grid.search.tooltip.groupEnabled": "按 ID 搜尋成員和群組",
  "memberProfileOverveiw.grid.search.tooltip": "按外部 ID 搜尋成員",
  "memberProfileOverveiw.grid.search.label": "搜尋",
  "memberProfileOverveiw.grid.btnCreateNewMember.label": "建立成員",
  "memberProfileOverveiw.grid.btnCreateNewGroup.label": "建立成員群組",
  "memberProfileOverveiw.grid.support.title": "忠誠支援",
  "memberProfileOverveiw.grid.title": "成員設定檔",
  "activityType.online_purchase.name": "購買",
  "activityType.redemption.name": "忠誠優惠",
  "activityType.exclusive_redemption.name": "點數存取",
  "activityType.customer_support.tierUpgrade.name": "層級升級",
  "activityType.customer_support.tierDowngrade.name": "降級層級",
  "activityType.customer_support.cashbackAdded.name": "新增的現金回饋",
  "activityType.customer_support.pointsAdded.name": "已新增 {{points_name}}",
  "activityType.customer_support.planChange.name": "已移轉至 {planName}/{planId}",
  "activityType.points_expiration.status.name": "狀態 {{points_name}} 已到期",
  "activityType.points_expiration.cachback.name": "現金回饋已到期",
  "activityType.tier_calculation.name": "計算的層級",
  "activityType.group_create.name": "建立的群組",
  "activityType.group_calculation.name": "計算的群組 ",
  "activityType.group_calculation.joinMember.name": "成員已加入群組",
  "activityType.group_calculation.leftMember.name": "成員已離開群組",
  "activityType.group_calculation.noChange.name": "群組活動",
  "activityType.group_delete.name": "已關閉群組",
  "activityType.additional_benefits.added.name": "新增的其他福利",
  "activityType.additional_benefits.removed.name": "移除的其他福利",
  "activityType.member_joined.name": "加入的忠誠",
  "activityType.points_migrated.name": "已移轉",
  "groupActivity": "群組活動",
  "activityElementType.purchase_points.negative": "移除的退貨點數",
  "activityElementType.purchase_points.positive.fromCatalog": "已從目錄購買",
  "activityElementType.purchase_points.positive.fromOnline": "購買",
  "activityElementType.byCustomerSupport": "客戶支援",
  "activityElementType.tierChange": "層級變更",
  "activityElementType.redemption_points": "點數兌換",
  "activityElementType.redemption_points.voucherRedemptionPoints": "點數憑證",
  "activityElementType.redemption_points.exclusiveRedemptionPoints": "點數存取",
  "activityElementType.redemption_points.voucherRedemptionCashback": "現金回饋憑證",
  "activityElementType.redemption_free": "免費兌換",
  "activityElementType.redemption_free.voucher": "免費憑證",
  "activityElementType.redemption_free.exclusive": "免費存取",
  "activityElementType.support_plan_change": "移轉的計劃",
  "activityElementType.plan_change_points": "移轉的點數",
  "activityElementType.plan_change_voucher": "移轉的獎勵",
  "activityElementType.contact_state.joinedGroup": "成員已加入群組",
  "activityElementType.contact_state.leftGroup.allGroupActivity": "成員已離開群組",
  "activityElementType.contact_state.leftGroup.onlyMemberLeft": "分配的共用點數",
  "rewardName.cashback": "現金回饋",
  "rewardName.tier": "層級",
  "rewardName.pointsAdditional": "其他 {{points_name}}",
  "rewardName.pointsBasic": "基本 {{points_name}}",
  "rewardName.pointsExtra": "額外 {{points_name}}",
  "rewardName.pointsBonus": "獎金 {{points_name}}",
  "rewardName.statusUpgrade": "升級的狀態",
  "rewardName.voucher": "憑證",
  "rewardName.exclusiveAccess": "專屬存取",
  "error.externalIdError.required": "輸入外部 ID",
  "error.externalIdError.exists": "此聯絡人已為忠誠成員。",
  "error.failToCreateMember": "建立此成員時發生錯誤。",
  "error.groupNameAlreadyExist": "此名稱已存在，請輸入唯一名稱。",
  "error.groupNameAlreadyExist.WithName": "此群組名稱 {groupName} 已存在，請輸入唯一名稱。",
  "error.failedToCreateGroup": "建立此群組時發生錯誤。",
  "error.failedToAddMembersToGroup": "將成員新增至群組時發生錯誤。",
  "createContactPopup.title": "建立成員",
  "createContactPopup.notification": "系統會根據忠誠管理設定中的會員設定，將新成員指派給層級。",
  "createContactPopup.multiPlanSelect.label": "選擇計劃",
  "createContactPopup.multiPlanSelect.tooltip": "選擇新成員要加入的方案。",
  "createContactPopup.externalId.tooltip": "若要新增忠誠成員，請輸入您在銷售資料中使用的相同外部 ID。",
  "createContactPopup.externalId.label": "輸入外部 ID",
  "success.createGroup": "已建立群組。",
  "success.addMembersToGroup": "已將成員新增至群組。",
  "createGroupPopup.saveBtn.disabled.tooltip.create": "若要建立群組，您必須至少將兩個成員新增至群組。",
  "createGroupPopup.saveBtn.disabled.tooltip.modify": "至少新增一個成員。",
  "createGroupPopup.saveBtn.disabled.tooltip.create.nameMissing": "輸入群組名稱。",
  "createGroupPopup.title.create": "建立成員群組",
  "createGroupPopup.title.modify": "新增成員",
  "createGroupPopup.notification": "若要建立群組，您必須至少將兩個成員新增至群組。如果成員已屬於群組，則搜尋結果不會顯示此成員。",
  "createGroupPopup.selectPlan.label": "選擇計劃",
  "createGroupPopup.selectPlan.tooltip": "您無法將不同計劃的成員新增至相同群組。",
  "createGroupPopup.groupName.tooltip": "建立群組識別碼的唯一名稱。建立群組後，您無法變更或複製此名稱。",
  "createGroupPopup.groupName.label": "群組名稱",
  "createGroupPopup.addMembers.label": "新增成員",
  "createGroupPopup.addMembers.tooltip": "按外部 ID 搜尋成員並新增至群組。",
  "groupMemebersTable.header.dateAdded": "已新增日期",
  "groupMemebersTable.header.lastActivityDate": "最後活動",
  "groupMemebersTable.header.removeFromGroup": "從群組移除",
  "groupProfileActivity.header.activity": "活動",
  "groupProfileActivity.header.tierExpiration": "層級到期",
  "groupProfileActivity.header.reward": "獎勵",
  "groupProfileActivity.header.value": "值",
  "groupProfileActivity.header.expiration": "到期",
  "groupProfileActivity.header.orderId": "訂單 ID",
  "groupProfileActivity.header.time": "時間",
  "groupProfileActivity.header.admin": "管理員",
  "groupProfileActivity.header.status": "狀態",
  "groupProfileActivity.search.tooltip": "按日期、活動或狀態搜尋。",
  "groupProfileActivity.header.totalPoints": "總點數",
  "groupProfileActivity.header.totalLoyaltyCredit": "總忠誠消費獎勵",
  "groupProfileActivity.header.activityType": "活動類型",
  "memberProfileActivity.search.tooltip": "按日期、活動、訂單 ID 或狀態搜尋。",
  "memberProfileAdditionalBenefitsPopup.title": "更新福利",
  "error.failToLoadData": "載入資料時發生錯誤。",
  "memberProfileAdditionalBenefitsPopup.notification": "您可在成員設定檔或忠誠 API 中管理其他福利。",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.label": "選擇福利",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.tooltip": "選擇要為此成員更新的福利。儲存更新後，成員便可使用福利。如果成員有包含已公開代碼的的兌換福利，則此福利會保留在成員的錢包中。",
  "memberProfileAdditionalBenefitsPopup.reason.tooltip": "輸入內部追蹤目的的原因。",
  "memberProfileAdditionalBenefitsPopup.reason.label": "原因",
  "memberProfileAdditionalBenefitsPopup.confirmCb.label": "我瞭解這些更新將影響成員的福利。",
  "memberProfileChangePlanPopup.title": "移轉計劃 ",
  "memberProfileChangePlanPopup.selectedPlan.label": "選擇計劃",
  "memberProfileChangePlanPopup.selectRewards.label": "選擇要移轉的獎勵",
  "memberProfileChangePlanPopup.selectRewards.tooltip": "選擇要移轉至新計劃的獎勵。如果您未選擇獎勵，則成員將在最低層級開始新計劃，且沒有點數和憑證。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.tooltip": "系統會根據新計劃中的狀態點數和層級設定，將成員指派給層級。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.label": "狀態 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.label": "餘額 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.tooltip": "系統會根據新計劃中的設定，重設點數有效期間並重新開始。",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.label": "待處理 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.tooltip": "待處理點數將自動核准並新增至狀態和餘額點數。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.tooltip": "兌換的憑證是忠誠錢包/API 中包含已公開代碼的憑證。即使已兌換固定福利多次使用憑證，也仍不會移轉。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.label": "兌換的憑證",
  "memberProfileChangePlanPopup.migrationConfirmation.label": "確認移轉",
  "memberProfileChangePlanPopup.migrationConfirmationCb.label": "將此成員移轉至新計劃後，便會取消目前計劃中的會員和活動。",
  "memberProfileDetails.tierDetails.plan": "計劃識別碼：{planId}",
  "memberProfileDetails.tierDetails.group": "群組名稱：{groupName}",
  "memberProfileDetails.tierDetails.joinedOn": "加入日期： ",
  "memberProfileDetails.tierDetails.createdOn": "建立日期：",
  "memberProfileDetails.tierDetails.groupMembers": "群組成員：{groupMembersNum}",
  "memberProfileDetails.tierDetails.personalInfo.firstName": "名字：{firstName}",
  "memberProfileDetails.tierDetails.personalInfo.lastName": "姓氏：{lastName}",
  "memberProfileDetails.tierDetails.personalInfo.email": "電子郵件：{email}",
  "memberProfileDetails.tierDetails.tierEntryDate": "層級輸入日期",
  "memberProfileDetails.tierDetails.nextTierRequirements": "下一個層級需求",
  "memberProfileDetails.pointsHistory.currentBalance.title": "目前餘額",
  "memberProfileDetails.pointsHistory.currentBalance.pointsToSpend": "可花費的 {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.expiresSoon": "即將到期",
  "memberProfileDetails.pointsHistory.currentBalance.groupStatus": "群組狀態 {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.groupPending": "群組待處理 {{points_name}}",
  "memberProfileUpdatePointsPopup.add.points.label": "新增 {{points_name}}",
  "memberProfileUpdatePointsPopup.remove.points.label": "移除 {{points_name}}",
  "memberProfileUpdatePointsPopup.remove.spend.label": "從餘額移除",
  "memberProfileUpdatePointsPopup.add.spend.label": "新增至餘額",
  "memberProfileUpdatePointsPopup.title.spend": "更新餘額",
  "memberProfileUpdatePointsPopup.title.points": "更新點數",
  "memberProfileUpdatePointsPopup.pointsType.spend": "餘額類型",
  "memberProfileUpdatePointsPopup.pointsType.points": "點數類型",
  "memberProfileUpdatePointsPopup.reason.tooltip": "輸入內部追蹤目的的更新原因。",
  "memberProfileUpdatePointsPopup.description.tooltip": "您可視需要輸入更新的原因，以便成員可在活動歷史記錄中查看。",
  "memberProfileUpdateTierPopup.options.invitationOnly": "{tierName} [僅邀請]",
  "memberProfileUpdateTierPopup.title": "更新層級",
  "memberProfileUpdateTierPopup.notification": "成員獲派層級後，該成員有權使用固定層級福利，並在層級計算設定中定義的期間內保留其狀態。",
  "memberProfileUpdateTierPopup.selectTier.placeholder": "-- 選擇層級 --",
  "memberProfileUpdateTierPopup.reason.tooltip": "針對內部追蹤目的，請輸入下列動作的原因：{text}",
  "memberProfileUpdateTierPopup.confirmCb.label": "我瞭解這些更新將影響 {text} 成員的忠誠狀態。",
  "tierDowngrade.points.options.status.name": "根據其目前點數，將成員降級至層級。",
  "tierDowngrade.points.options.tier.name": "將成員降級至特定層級。",
  "tierDowngrade.points.options.tier.tooltip": "狀態點數已更新為此層級所需的最低值。",
  "tierDowngrade.spend.options.status.name": "根據其目前忠誠消費獎勵，將成員降級至層級。",
  "tierDowngrade.spend.options.tier.name": "將成員降級至特定層級。",
  "tierDowngrade.spend.options.tier.tooltip": "忠誠消費獎勵已更新為此層級所需的最低值。",
  "tierUpdate.options.tierUpgrade.name": "升級層級",
  "tierUpdate.options.tierDowngrade.name": "降級層級",
  "membersReportDownloadButton.tooltip": "成員狀態報表是包含成員忠誠狀態資訊的 CSV 檔案。下載可能需要數分鐘的時間。",
  "membersReportDownloadButton.label": "下載成員狀態報表",
  "updatePointsType.points.options.loyalty": "忠誠 {{points_name}} (狀態 {{points_name}} 和花費 {{points_name}})",
  "updatePointsType.points.options.status": "僅狀態 {{points_name}}",
  "updatePointsType.points.options.spend": "僅花費 {{points_name}}",
  "updatePointsType.spend.options.status": "僅狀態 {{points_name}}",
  "updatePointsType.spend.options.cashback": "僅現金回饋",
  "memberPointsUpdateValidator.confirmed.isTrue": "請確保您輸入所有必要資訊。",
  "memberPointsUpdateValidator.reason.presence": "輸入內部追蹤目的的原因。",
  "memberPointsUpdateValidator.pointsValue.presence": "輸入大於零的數字作為點數數量。",
  "memberPointsUpdateValidator.pointsValue.numericality.notInteger": "輸入大於零的數字作為點數數量。",
  "memberPointsUpdateValidator.pointsValue.numericality.notGreaterThan": "輸入大於零的數字作為點數。",
  "memberPointsUpdateValidator.pointsValue.numericality.notLessThan": "輸入小於 100,000 的點數。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.messageLoyaltyPoints": "移除的點數數量無法大於現有的點數數量。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.message": "移除的點數數量無法大於現有的點數數量。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.message": "移除的點數數量無法大於成員目前有的點數。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.messageCashback": "移除的現金回饋數量無法大於現有的現金回饋值。",
  "memberTierUpdateValidator.tierDowngradeType": "選擇降級類型。",
  "memberTierUpdateValidator.selectedTierId": "選擇層級。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.status": "移除此成員後，累計的狀態點數會從成員狀態移除。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.loyality": "移除此成員後，累計的忠誠消費獎勵會從成員狀態移除。",
  "memberGroupProfile.updatePointsBtn.label.points": "更新點數",
  "memberGroupProfile.updatePointsBtn.label.balance": "更新餘額",
  "memberProfile.updatePointsBtn.label.points": "更新點數",
  "memberProfile.updatePointsBtn.label.balance": "更新餘額",
  "memberGroupProfile.removeFromGroup.deleteDialog.content": "移除此成員後，累計的{pointType}會從群組狀態移除。",
  "memberGroupProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} 其他 {Balance}}",
  "memberProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} 其他 {Balance}}",
  "activityType.customer_support.cashbackRemoved.name": "移除的現金回饋 ",
  "activityType.customer_support.pointsRemoved.name": "已移除 {{points_name}}",
  "activityType.points_expiration.toSpend.name": "餘額 {{points_name}} 已過期",
  "memberProfileUpdatePointsPopup.confirmed.label": "我瞭解這些更新將影響 {text} 成員的忠誠狀態。"
}
